import { render, staticRenderFns } from "./metro-detail.vue?vue&type=template&id=657f2ac3&scoped=true"
import script from "./metro-detail.vue?vue&type=script&lang=js"
export * from "./metro-detail.vue?vue&type=script&lang=js"
import style0 from "./metro-detail.vue?vue&type=style&index=0&id=657f2ac3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657f2ac3",
  null
  
)

export default component.exports